<template>
    <div>
      <div class="bg-gray-900 p-6 rounded-2xl shadow space-y-6 max-w-3xl mx-auto">
        <h1 class="text-2xl font-bold mb-6">Create New Opportunity</h1>
        <form @submit.prevent="createOpportunity" class="space-y-4">
  
          <!-- Title -->
          <div>
            <label class="block text-sm mb-1">Title</label>
            <input
              v-model="form.title"
              type="text"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="Opportunity Title"
            />
          </div>
  
          <!-- Organization -->
          <div>
            <label class="block text-sm mb-1">Organization</label>
            <input
              v-model="form.organization"
              type="text"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="Organization Name"
            />
          </div>
  
          <!-- Location -->
          <div>
            <label class="block text-sm mb-1">Location</label>
            <input
              v-model="form.location"
              type="text"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="City, Country / Online"
            />
          </div>

          <!-- Category -->
          <div>
            <label class="block text-sm mb-1">Category</label>
            <select
              v-model="form.category"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
            >
              <option :value="item.key" v-for="item in categories" :key="item.key" v-html="item.name"></option>
            </select>
          </div>
  
          <!-- Mode -->
          <div>
            <label class="block text-sm mb-1">Mode</label>
            <select
              v-model="form.mode"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
            >
              <option value="in-person">In-Person</option>
              <option value="virtual">Virtual</option>
              <option value="hybrid">Hybrid</option>
            </select>
          </div>
  
          <!-- Deadline -->
          <div>
            <label class="block text-sm mb-1">Deadline</label>
            <input
              v-model="form.deadline"
              type="date"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
            />
          </div>
  
          <!-- Tags -->
          <div>
            <label class="block text-sm mb-1">Tags (comma separated)</label>
            <input
              v-model="tagsInput"
              type="text"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="Leadership, Summer Program, Online"
            />
          </div>
  
          <!-- Description -->
          <div>
            <label class="block text-sm mb-1">Description</label>
            <textarea
              v-model="form.description"
              rows="5"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="Describe the opportunity..."
            ></textarea>
          </div>
  
          <!-- Apply Link -->
          <div>
            <label class="block text-sm mb-1">Apply Link</label>
            <input
              v-model="form.link"
              type="url"
              class="w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500"
              placeholder="https://example.com/apply"
            />
          </div>
  
          <!-- Submit Button -->
          <div class="pt-4">
            <primary-button class="w-full">Create Opportunity</primary-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import PrimaryButton from '../../components/button/PrimaryButton.vue'
  import { getAllCategories } from '@/utils/category'
  import { storeOpportunity } from '@/utils/opportunity'

  const router = useRouter()
  
  const form = ref({
    id: '',
    title: '',
    organization: '',
    location: '',
    category: '',
    mode: '',
    description: '',
    tags: [],
    deadline: '',
    link: '',
  })
  const categories = ref({})
  const tagsInput = ref('')

  const explodeTags = () => {
    form.value.tags = tagsInput.value.split(',').map(tag => tag.trim())
    return true
  }
  const createOpportunity = async () => {
    explodeTags()
    const opportunity = await storeOpportunity(form.value)

    if (opportunity == true)
    {
      router.push('/admin/opportunities') // Redirect back to listing
    } else {
      alert('Something went wrong!')
    }

  }

  onMounted(async () => {
    categories.value = await getAllCategories()
  })
</script>
  